import * as menu from "store/actions/menu";
import { STORAGE_MINI, readStorage, writeStorage } from "layout/menuConfig";

const initialState = {
    isOpen: window.innerWidth > 960,
    // Icons-only sidebar on desktop; the preference survives reloads.
    mini: readStorage(STORAGE_MINI, false) === true,
};

function appReducer(state = initialState, action) {
    switch (action.type) {
        case menu.ACTION_TOOGLE_MENU:
            return { ...state, isOpen: !state.isOpen };
        case menu.ACTION_CHANGE_OPEN:
            return { ...state, isOpen: Boolean(action.open) };
        case menu.ACTION_TOGGLE_MINI: {
            const mini = !state.mini;
            writeStorage(STORAGE_MINI, mini);
            return { ...state, mini };
        }
        case menu.ACTION_SET_MINI: {
            const mini = Boolean(action.mini);
            writeStorage(STORAGE_MINI, mini);
            return { ...state, mini };
        }
        default:
            return state;
    }
}

export default appReducer;
